import { render } from "./TheTeam.vue?vue&type=template&id=a6f5846c&scoped=true"
import script from "./TheTeam.vue?vue&type=script&lang=js"
export * from "./TheTeam.vue?vue&type=script&lang=js"

import "./TheTeam.vue?vue&type=style&index=0&id=a6f5846c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mraha\\Pictures\\tandzorggestel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6f5846c"]])

export default __exports__